import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { GenericApiCall } from '../../../../common/store/types';
import { Observable } from 'rxjs';
import { PaymentEntryModel } from '../../../../shared/store/accounting/types';
import { AccountingService } from '../../../../shared/store/accounting/accounting.service';
import { SourceEnum } from '../../../../shared/store/typeahead/types';
import { SubHeaderService } from '../../../../shared/store/subheader/subheader.service';
import { ModalService } from '../../../../shared/service/modal.service';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { SearchService } from '../../../../shared/store/search/search.service';
import { take } from 'rxjs/operators';
import {
  ModalComponent,
  ModalComponentKey,
} from 'src/app/shared/service/modal-component';

@UntilDestroy()
@ModalComponent(ModalComponentKey.ChequeRemittanceFormCheques)
@Component({
  selector: 'app-cheque-remittance-form-cheques-content',
  standalone: false,
  templateUrl: './cheque-remittance-form-cheques-content.component.html',
  styleUrl: './cheque-remittance-form-cheques-content.component.scss',
})
export class ChequeRemittanceFormChequesContentComponent
  implements OnInit, OnDestroy
{
  @Input() modalRandomIdentifier: number;
  @Input() source: SourceEnum = SourceEnum.Component;

  apiCall: GenericApiCall<any, any>;
  paymentEntryModels$: Observable<PaymentEntryModel[]>;
  paymentEntryModels: PaymentEntryModel[] = [];
  paymentEntryModelIds: number[] = [];

  constructor(
    private readonly accountingService: AccountingService,
    private readonly subHeaderService: SubHeaderService,
    private readonly searchService: SearchService,
    private readonly dynamicService: ModalService,
  ) {
    this.paymentEntryModels$ = this.accountingService.getPayments.value$;
  }

  ngOnInit(): void {
    this.apiCall = this.accountingService.getPayments;

    this.accountingService.getPayments.call('Cheque');

    this.subHeaderService
      .getTriggerAction()
      .pipe(untilDestroyed(this))
      .subscribe((x) => {
        if (x == 'chequeRemittanceSelectCheques')
          this.onChequeRemittanceSelectCheques();

        this.subHeaderService.setTriggerAction('');
      });

    this.searchService
      .getSelectedRows()
      .pipe(take(1))
      .subscribe((selectedRows) => {
        if (selectedRows.data.length == 0) return;

        this.paymentEntryModels = selectedRows.data;
        this.paymentEntryModelIds = this.paymentEntryModels.map(
          (item) => item.accountMoveId,
        );
      });
  }

  ngOnDestroy(): void {
    this.accountingService.getPayments.reset();
  }

  private onChequeRemittanceSelectCheques() {
    switch (this.source) {
      case SourceEnum.Component:
        // if (result.id == user.contactId) {
        //   this.userService.getCurrentUser.call();
        // }
        // this.router.navigate(['/Contacts/Contacts/Details', result.id]);
        break;
      case SourceEnum.Modal:
        this.dynamicService.outputFromDynamicComponent(
          this.modalRandomIdentifier,
          '1', //to close the modal
        );
        break;
      default:
        // this.router.navigate(['/Contacts/Contacts/Details', result.id]);
        break;
    }
  }
}
